import Keycloak, { KeycloakConfig, KeycloakInitOptions } from 'keycloak-js';

export const config: KeycloakConfig = {
	url: import.meta.env.VITE_KEYCLOAK_AUTH_URL,
	clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID,
	realm: import.meta.env.VITE_KEYCLOAK_REALM_NAME,
};

export let keycloak: Keycloak | null = null;

export const getKeycloakInstance = (): Keycloak | null => keycloak;

export const initKeycloakInstance = (cfg: KeycloakConfig = config) => {
	if (!keycloak) {
		keycloak = new Keycloak(cfg);
	}
	return keycloak;
};

export const keycloakInitConfig: KeycloakInitOptions = {
	onLoad: 'check-sso',
	pkceMethod: 'S256',
	checkLoginIframe: false,
};

export const broadcastChannelLogoutEvent = 'logout';
